// Calculate the finance prices for Klarna/Clearpay
function getFinancePrice(currentPrice, intervals) {
    let qtyElement = document.getElementById('main-product-qty').querySelector('#quantity');

    if (qtyElement && typeof qtyElement !== "undefined") {
        let qty = qtyElement.value;
        let intervalPrice = (currentPrice * qty) / intervals;

        return currencyFormatter.format(intervalPrice);
    }

    return null;
}

function calculateFinancePrices() {
    return setTimeout(function () {
        let currentPriceWrapper = $('.product-price-wrapper').filter(':visible'),
            currentPrice = parseFloat(currentPriceWrapper.find('.price__regular').find('.price-item').text().replace('.00', '').replace(/[^0-9\.-]+/g, ""));

        let klarnaFinance = getFinancePrice(currentPrice, 3);
        if ($('#klarna-widget').length > 0 && klarnaFinance)
            $('#klarna-widget').find('.price').text(klarnaFinance + '\xa0');

        let clearPayFinance = getFinancePrice(currentPrice, 4);
        if ($('#clearpay-widget').length > 0 && clearPayFinance)
            $('#clearpay-widget').find('.price').text(clearPayFinance + '\xa0');
    }, 100);
}

function isEmptyQty(qty) {
    if (qty === "" || isNaN(qty))
        return true;

    return false;
}

function limitChecker(qty, maxQty) {
    if (qty < maxQty)
        return false;
    else if (qty == maxQty)
        return false;
    else
        return true;
}

function updateInputBounds(event) {
    let dropdown = event.target;
    let selectedOption = dropdown.options[dropdown.selectedIndex];

    if (selectedOption) {
        let quantity = parseFloat(selectedOption.getAttribute("data-variant-stock"));

        $("#main-product-qty .qty_wrap .qty_input").attr("max", quantity);
    }
}

// Product Page/Modal Qty Clickers
$('#main-product-qty .qty_wrap .qty_button').on('click', function () {
    var qty = $(this).parent('.qty_wrap').find('.qty_input').val();

    if ($(this).hasClass('qty_plus')) {
        qty++;
    } else {
        if (qty > 1)
            qty--;
    }
    $(this).parent('.qty_wrap').find('.qty_input').val(qty);
    calculateFinancePrices();
});

document.addEventListener("DOMContentLoaded", function () {
    if (document.querySelector('.product__form-wrapper')) {
        let currentPriceWrapper = $('.product-price-wrapper').filter(':visible'),
            currentPrice = parseFloat(currentPriceWrapper.find('.price__regular').find('.price-item').text().replace('.00', '').replace(/[^0-9\.-]+/g, ""));

        let klarnaFinance = getFinancePrice(currentPrice, 3);
        if ($('#klarna-widget').length > 0 && klarnaFinance)
            $('#klarna-widget').find('.price').text(klarnaFinance + '\xa0');

        let clearPayFinance = getFinancePrice(currentPrice, 4);
        if ($('#clearpay-widget').length > 0 && clearPayFinance)
            $('#clearpay-widget').find('.price').text(clearPayFinance + '\xa0');

        $('.variant-selector').on('select2:select', function (e) {
            calculateFinancePrices();
            updateInputBounds(e);
        });

        $('input[type=radio][name=filling]').change(function () {
            calculateFinancePrices();
        });
    }

    const noMoreQty = "can't add anymore.";

    $("#main-product-qty .qty_wrap .qty_input").on("input", function(event) {
        if (event.target.value !== "" && limitChecker(parseFloat(event.target.value), parseFloat(event.target.getAttribute("max"))))
            $(this).closest('.product__quantity-wrapper').find('.qty-msg').text(noMoreQty).show();
        else
            $(this).closest('.product__quantity-wrapper').find('.qty-msg').text("").hide();
        calculateFinancePrices();
    });

    $("#main-product-qty .qty_wrap .qty_input").on("change", function(event) {
        let emptyQty = isEmptyQty(parseFloat(event.target.value));
        if (emptyQty)
            $(this).val($(this).attr("min"));
        else
            $(this).val($(this).attr("max"));

        $(this).closest('.product__quantity-wrapper').find('.qty-msg').text("").hide();
        calculateFinancePrices();
    });
});